// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton-styles-module--button--8ipSA","arrow":"BackButton-styles-module--arrow--3h9Yp"};